import { useQuery } from '@tanstack/react-query';
import deviceTypeService from '../services/deviceTypeService';

export const useDeviceTypes = (params?: {
  page?: number;
  limit?: number;
  search?: string;
  is_active?: boolean;
}) => {
  return useQuery({
    queryKey: ['deviceTypes', params],
    queryFn: () => deviceTypeService.getAll(params),
  });
};

export const useActiveDeviceTypes = () => {
  return useQuery({
    queryKey: ['deviceTypes', 'active'],
    queryFn: () => deviceTypeService.getActive(),
  });
};

export const useDeviceType = (id: number) => {
  return useQuery({
    queryKey: ['deviceTypes', id],
    queryFn: () => deviceTypeService.getById(id),
    enabled: !!id,
  });
};